import { extractErrorMessage } from '@/api/http';
import { ElMessage } from 'element-plus';

export type NotifyType = 'success' | 'error' | 'warning' | 'info';

export interface NotifyOptions {
  type?: NotifyType;
  message: string;
  duration?: number;
}

export const notifyService = {
  show(opts: NotifyOptions) {
    ElMessage({ type: opts.type, message: opts.message, duration: opts.duration ?? 2000 });
  },
  success(message: string, duration?: number) {
    ElMessage({ type: 'success', message, duration: duration ?? 2000 });
  },
  error(message: string, duration?: number) {
    ElMessage({ type: 'error', message, duration: duration ?? 2000 });
  },
  warning(message: string, duration?: number) {
    ElMessage({ type: 'warning', message, duration: duration ?? 2000 });
  },
  info(message: string, duration?: number) {
    ElMessage({ type: 'info', message, duration: duration ?? 2000 });
  },
  fromError(err: unknown, fallback = '操作失败') {
    const msg: string = extractErrorMessage(err) || fallback;
    ElMessage({ type: 'error', message: msg, duration: 2000 });
    return msg;
  },
};
